import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { TutorialButton } from '@ro-components/Tutorial';

export const menuTutorial = (id, buttonText) => [
  {
    element: '.menu_settings',
    intro:
      'Jak by to było gdyby opcji nie było. ;) Tutaj możesz znaleźć opcje dla róźnych sekcji. Pójdziemy do nich za moment.'
  },
  {
    element: '.menu_license',
    intro:
      'W tej sekcji dowiesz się wszystko na temat licencji poszczególnych produktów, oraz warunków ich wykorzystania.'
  },
  {
    element: '.menu_faq',
    intro: 'Ta sekcja zawiera odpowiedzi na nurtujące Cię pytania. Pewnie nie wszystkie. ;)'
  },
  // {
  //   element: '.menu_version',
  //   intro:
  //     'Z tego poziomu przejdziesz do dyskusji na temat aplikacji. Możesz zgłosić tam błąd lub przeczytać informacje o aktualnym wydaniu',
  // },
  {
    element: '.menu_sp',
    intro: `No to chodźmy do ustawień - obiecaliśmy ;). Zacznijmy od Skypredict. ${ReactDOMServer.renderToStaticMarkup(
      <TutorialButton id={id} text={buttonText} />
    )}`
  }
];
